import { faqActionsEnum } from 'actions/HelpCentreActions/faqActions';
import { catalogActionsEnum } from 'actions/HelpCentreActions/catalogActions';
import { searchActionsEnum } from 'actions/HelpCentreActions/searchAction';
import { LOGIN_TO_VIEW } from 'fk-cp-common-components/actions/myOrdersActions';
import { SET_VIEW_TYPE } from 'actions/viewType';
import { orderIssueActionsEnum } from 'actions/HelpCentreActions/OrderIssueActions';
import { issueFaqActionsEnum } from 'actions/HelpCentreActions/issueFaqActions';
import { serviceTicketActionsEnum } from 'actions/HelpCentreActions/serviceTicketActions';
import { getContextActionsEnum } from 'actions/HelpCentreActions/getContextActions';
import viewTypes from 'constants/HelpCentreConstants';
import ExecutionEnvironment from 'fbjs/lib/ExecutionEnvironment';
const defaultState = viewTypes.INIT;
export default function viewType(state = defaultState, action = {
    type: null
}) {
    if (!ExecutionEnvironment.canUseDOM)
        return defaultState;
    switch (action.type) {
        case catalogActionsEnum.SELECT_CATALOG:
            return viewTypes.CATALOG;
        case faqActionsEnum.FAQ_REQUEST:
        case faqActionsEnum.FAQ_SUCCESS:
            return viewTypes.FAQ;
        case getContextActionsEnum.GET_CONTEXT_REQUEST:
        case getContextActionsEnum.GET_CONTEXT_SUCCESS:
            return viewTypes.INIT;
        case orderIssueActionsEnum.GET_ORDER_ISSUES_REQUEST:
        case orderIssueActionsEnum.GET_ORDER_ISSUES_SUCCESS:
            return viewTypes.ORDER_ISSUE;
        case searchActionsEnum.SEARCH_QUERY:
            return viewTypes.SEARCH;
        case issueFaqActionsEnum.ISSUEFAQ_SUCCESS:
        case issueFaqActionsEnum.ISSUEFAQ_REQUEST:
            return viewTypes.ISSUE_FAQ;
        case LOGIN_TO_VIEW:
            return viewTypes.LOGIN;
        case issueFaqActionsEnum.STATIC_ISSUE_REQUEST:
        case issueFaqActionsEnum.STATIC_ISSUE_SUCCESS:
            return viewTypes.NON_ORDER_ISSUE;
        case serviceTicketActionsEnum.SERVICE_TICKET_REQUEST:
            return viewTypes.SERVICE_TICKETS;
        case SET_VIEW_TYPE:
            return viewTypes[action.data] ? action.data : state;
        default:
            return state;
    }
}
